import { useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"
import { HttpCodes } from "@/constants/globals"
import { AppDispatch, RootState } from "@/store"
import { clearAlert } from "@/store/alertsSlice"

export const useFastClearAlert = () => {
   const dispatch = useDispatch<AppDispatch>()
   const { firstName, lastName } = useSelector(
      ({ userReducer }: RootState) => userReducer
   )

   const handleClearAlert = useCallback(
      async (alertId: string, onSuccess?: () => void) => {
         try {
            const result = await dispatch(
               clearAlert({
                  alertId: alertId,
                  clearReport: {
                     name: `${firstName} ${lastName}`,
                     reportNote: "Fast clearance",
                  },
               })
            ).unwrap()
            if (result.status === HttpCodes.OK) {
               onSuccess?.()
            }
         } catch (error) {
            console.error("Error fast clearing alert:", error)
         }
      },
      [dispatch, firstName, lastName]
   )

   return { handleClearAlert }
}
